import { Col } from "antd";
import { mainActions } from "../../store/main/mainSlice";
import { useDispatch } from "react-redux";
import { ItemProps } from "../Interfaces/ItemsTable";
type PropsType = {
  items: ItemProps[];
};
const ItemsListNew = ({ items }: PropsType) => {
  const dispatch = useDispatch();
  return (
    <>
      {items &&
        items.map((item: any, index: number) => {
          return (
            <Col className="card" key={index}>
              <div
                onClick={() => {
                  dispatch(
                    mainActions.addItem({
                      name: item.item.name,
                      itemId: item.item.id,
                      barcode: item.item.barcode,
                      cost: item.averageCost,
                      price: item.lastPrice,
                      totalPrice: item.lastPrice,
                      isTaxable: false,
                      extraCharge: 0,
                      tax: 10,
                      discount: null,
                      notes: "",
                      qty: 1,
                      specifications: [],
                    })
                  );
                }}
              >
                <img
                  src={require("./Images/bread.png")}
                  alt=""
                  style={{
                    height: "6rem",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
                <h4 className="card-txt">{item?.item?.name}</h4>
                <p className="card-txt">{item?.description}</p>
                <h4 style={{ float: "right" }}>
                  {item?.lastPrice} {item?.currency.symbol}
                </h4>
              </div>
            </Col>
          );
        })}
    </>
  );
};

export default ItemsListNew;
